export default {"src":"/_next/static/media/chevrons-down.b26cb66f.svg","height":800,"width":800};